/** @typedef {import('./types').CrmHealth} CrmHealth */

/** The four parts of the 0-100 health score, with their maximum points (from the API contract). */
export const HEALTH_FACTORS = [
    { key: 'Engagement', label: 'Engagement', max: 30 },
    { key: 'Relationship', label: 'Relationship / deal', max: 20 },
    { key: 'Compliance', label: 'Compliance', max: 30 },
    { key: 'Tickets', label: 'Tickets', max: 20 },
]

export const HEALTH_LEGEND =
    'Score = engagement (last conversation) + relationship (customer or deal stage) + compliance (last 3 inspection scores and trend) + tickets (overdue and open). 75+ healthy, 50–74 watch, under 50 at risk.'

/** UI tone for a health band; anything unknown is neutral. */
export const bandTone = band => (['green', 'amber', 'red'].includes(band) ? band : 'gray')

/**
 * Bar fill 0-100 for one factor. Clamped, and safe for a missing value.
 * @param {number|null|undefined} value
 * @param {number} max
 */
export const factorPercent = (value, max) => {
    const v = Number(value)
    if (!Number.isFinite(v) || max <= 0) return 0
    return Math.max(0, Math.min(100, Math.round((v / max) * 100)))
}

/** Colour of one factor bar from its own fill: 75%+ green, 40%+ amber, otherwise red. */
export const factorTone = percent => {
    if (percent >= 75) return 'green'
    return percent >= 40 ? 'amber' : 'red'
}

/** "Customer Health 76 · Healthy" */
export const healthHeadline = (accountType, health) =>
    health ? `${accountType ? `${accountType} ` : ''}Health ${health.Score} · ${health.Label}` : ''

/**
 * Only http(s) links are clickable. A bare domain such as "cedarline.example" gets https://;
 * any other scheme (javascript:, data:, ...) is refused and the text is shown unlinked.
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export const safeLink = url => {
    const text = String(url || '').trim()
    if (!text) return null
    if (/^https?:\/\//i.test(text)) return text
    if (/^[a-z][a-z0-9+.-]*:/i.test(text)) return null // some other scheme
    return /^[\w-]+(\.[\w-]+)+(\/\S*)?$/.test(text) ? `https://${text}` : null
}
